import { CMSCollection, ICMS } from '@typedream/data';
import {
  SelectValue,
  SelectTrigger,
  Text,
  Select,
  SelectItem,
  SelectContent,
  SelectLabel,
  SelectGroup,
  SelectSeparator,
} from '@typedream/ui';
import { CMSColumnTypeIcons } from './constants';

export function ColumnOptions({
  collection,
  value,
  setvalue,
}: {
  collection: CMSCollection;
  value: string;
  setvalue: (val: string) => void;
}) {
  const collectionSchema = collection.field.schema;
  const collectionPresetSchema = collection.field.preset_schema;

  const additionalColumns = {
    ITEM_PAGE_URL: {
      name: "Item's Page URL",
      type: 'url',
    },
  };
  const excludedColumns: (keyof ICMS['field']['preset_schema'])[] = [
    'published_content',
    'content',
    'metadata',
  ];

  const possibleColumnKeys = Object.keys(collectionSchema)
    .concat(Object.keys(collectionPresetSchema))
    .concat(Object.keys(additionalColumns));
  const currentVal = possibleColumnKeys.includes(value) ? value : undefined;

  return (
    <Select value={currentVal} onValueChange={(val) => setvalue(val)}>
      <SelectTrigger className="text-secondary">
        <SelectValue placeholder="Select a column" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Select a column</SelectLabel>
          {Object.entries(collectionPresetSchema).map(([key, val]) =>
            val.deleted ? null : (
              <SelectItem value={key} key={key}>
                <div className="flex gap-2.5 items-center justify-between">
                  <Text size="2xs" weight="regular" variant="secondary" className="leading-none">
                    {CMSColumnTypeIcons[val.type]}
                  </Text>
                  <Text size="xs" weight="regular" variant="main">
                    {val.name}
                  </Text>
                </div>
              </SelectItem>
            )
          )}
          {additionalColumns &&
            Object.entries(additionalColumns).map(([key, val]) => (
              <SelectItem value={key} key={key}>
                <div className="flex gap-2.5 items-center justify-between">
                  <Text size="2xs" weight="regular" variant="secondary" className="leading-none">
                    {CMSColumnTypeIcons[val.type]}
                  </Text>
                  <Text size="xs" weight="regular" variant="main">
                    {val.name}
                  </Text>
                </div>
              </SelectItem>
            ))}
          {Object.keys(collectionSchema).length > 0 ? <SelectSeparator /> : null}

          {Object.entries(collectionSchema).map(([key, val]) =>
            val.deleted || (excludedColumns as string[]).includes(key) ? null : (
              <SelectItem value={key} key={key}>
                <div className="flex gap-2.5 items-center justify-between">
                  <Text size="2xs" weight="regular" variant="secondary" className="leading-none">
                    {CMSColumnTypeIcons[val.type]}
                  </Text>
                  <Text size="xs" weight="regular" variant="main">
                    {val.name}
                  </Text>
                </div>
              </SelectItem>
            )
          )}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
